<template>
  <div>
    <el-button style="width:100%;" type="secondary" size="small" @click="open">스크립트 수행</el-button>
    <w-sliding-popup ref="slidingPopup" :default-content="false" title="스크립트 수행" top="50px" width="850px" @close="close">
      <div class="body-no-footer body-content" slot="content">
        <el-row v-loading="isLoading" style="margin-bottom:15px;">
          <el-input type="textarea" :rows="12" placeholder="수행 결과 콘솔" :readonly="true" v-model="resultConsoleData"></el-input>
        </el-row>
        <el-row class="vertical-center-box" style="margin-bottom:15px;">
          <span :style="objManagetypeId === 'SMS' ? 'width:80px;' : 'width:74px;'">
            <span>명령어</span>
            <el-popover v-show="objManagetypeId === 'SMS'" placement="right" width="250" trigger="click" title="수행 불가 명령어" :offset="40">
              <el-table-wrapper :data="forbiddenCommandList" :columns="forbiddeTableColumns" :column-default="columnDefault" :max-height="250" :pagination="false"></el-table-wrapper>
              <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
            </el-popover>
          </span>
          <el-input class="mr-r4" type="text" size="mini" :style="objManagetypeId === 'SMS' ? 'width:calc(100% - 80px);' : 'width:calc(100% - 74px);'" v-model="commandText" @keyup.enter.native="onTextFieldKeyupEnter">
          </el-input>
          <el-button class="mr-r4" type="primary" size="mini" @click="onPerformCommandButtonClick(commandText, true, null)">수행</el-button>
          <el-button size="mini" @click="onConsoleClearButtonClick">결과 초기화</el-button>
        </el-row>
        <hr class="mr-b20" />
        <!-- 서버 > 명령어 수행 -->
        <el-row style="height:calc(100% - 343px);" v-if="objManagetypeId === 'SMS'">
          <el-col :span="4"><div class="title-h4 title-bar">스크립트 실행</div></el-col>
          <!-- <el-col :span="20" class="mr-b10 btn-group-right">
            <span>스크립트 설정은 환경설정에서 가능합니다.</span>
            <i class="fas fa-cog" style="cursor: pointer" @click="onSettingButtonClick"></i>
          </el-col> -->
          <el-table-wrapper style="height:calc(100% - 40px);" height="100%" :data="serverCommandList" :columns="serverCommandTableColumns" :column-default="columnDefault" row-class-name="c-pointer" :pagination="false">
            <template slot-scope="scope" slot="slot">
              <el-button size="mini" @click="onPerformCommandButtonClick(scope.row.commandContents, false, scope.row.commandName)">수행</el-button>
            </template>
          </el-table-wrapper>
        </el-row>
        <!-- 네트워크 장비 > 명령어 수행 -->
        <el-row style="height:calc(100% - 343px);" v-else :gutter="10">
          <el-col style="height:100%;" :span="12">
            <div class="title-h4 dot-title title-bar" style="height:28px;">제어 스크립트 수행</div>
            <!-- <span>스크립트 설정은 환경설정에서 가능합니다.</span>
            <i class="fas fa-cog" style="cursor: pointer" @click="onSettingButtonClick"></i> -->
            <el-table-wrapper style="height:calc(100% - 40px);" height="100%" :data="netdeviceScriptList" :columns="netdeviceScriptTableColumns" :column-default="columnDefault" row-class-name="c-pointer" :pagination="false" @row-click="onScriptRowClick"></el-table-wrapper>
          </el-col>
          <el-col style="height:100%" :span="12" class="list form-list">
            <!-- 선택한 스크립트가 존재할 경우 -->
            <div v-if="selectedScriptInfo !== null" style="height:100%">
              <el-row class="title-bar" type="flex" justify="space-between">
                <div class="vertical-center-box">
                  <div class="title-h4 dot-title mr-r10">{{ selectedScriptInfo.templateName }} 스크립트 정보</div>
                  <el-popover placement="right" trigger="click" width="400" title="" :offset="40" @show="updateLegendTableLayout">
                    <el-table-wrapper ref="legendTable" style="height: 400px;" :fit-height="true" :data="legendDescList" :columns="legendTableColumns" :column-default="columnDefault" :pagination="false"></el-table-wrapper>
                    <span slot="reference"><i class="fas fa-info-circle c-pointer"></i></span>
                  </el-popover>
                </div>
                <el-button class="mr-r4" size="mini" type="primary" @click="onPerformCommandButtonClick(selectedScriptInfo.script, false, selectedScriptInfo.templateName)">수행</el-button>
              </el-row>
              <el-form style="height:calc(100% - 40px);" v-if="selectedScriptInfo !== null" label-position="left" label-width="50px">
                <el-form-item label="스크립트 명"><span>{{ selectedScriptInfo.templateName }}</span></el-form-item>
                <el-form-item label="설명"><span>{{ getTableValueAfterCheckEmpty('', '', selectedScriptInfo.templateDescr) }}</span></el-form-item>
                <el-form-item label="스크립트">
                  <el-input type="textarea" :rows="10" v-model="selectedScriptInfo.script"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <!-- 선택한 스크립트가 존재하지 않을 경우 -->
            <el-row v-else class="vertical-center-box" style="height:100%;border: 1px solid #eee; color:#666;" type="flex" justify="center">
              스크립트를 선택해주십시오.
            </el-row>
          </el-col>
        </el-row>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { isEmpty } from '@/utils/basic';
import { getValueAfterCheckEmpty } from '@/utils/string';
import MsgUtil from '@/utils/message';
import serverAPI from '@/api/performance/server/info-table';
import netdeviceAPI from '@/api/performance/netdevice/netdevice-info';
import configAPI from '@/api/config/netdevice/netdevice-info';
import basicInfoAPI from '@/api/model/basicinfo-sub';

export default {
  name: 'WCommonScriptPopupButton',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      popupVisible: false,
      isLoading: false,
      commandText: '',
      resultConsoleData: '',
      selectedScriptInfo: null,
      forbiddenCommandList: [],
      serverCommandList: [],
      netdeviceScriptList: [],
      columnDefault,
      legendDescList: [
        { value: '$send$', desc: '명령어를 보냅니다.' },
        { value: '$expect$', desc: '특정 문자열이 올 때까지 기다립니다.' },
        { value: '$user_id$', desc: '로그인 이름' },
        { value: '$password$', desc: '패스워드' },
        { value: '$privilegePassword$', desc: 'Enable 패스워드' },
        { value: '$expectpromt$', desc: '저장된 프롬프트가 올 때까지 대기합니다.' },
        { value: '$usepromt$', desc: '로그인 성공 후 프롬프트로 사용합니다.' },
        { value: '$sendEM$', desc: '제어 문자 EM을 보냅니다.' },
        { value: '$changePwId$', desc: '패스워드 변경 아이디' },
        { value: '$changePw$', desc: '변경 패스워드' },
        { value: '$beforePw$', desc: '기존 패스워드' },
        { value: '$fullpath$', desc: '장비 펌웨어 경로' },
        { value: '$ipaddress$', desc: '파일 서버 IP 주소' },
        { value: '$scpId$', desc: 'SCP 아이디' },
        { value: '$scpPw$', desc: 'SCP 패스워드' },
        { value: '$path$', desc: '업데이트 펌웨어 경로' },
        { value: '$filename$', desc: '펌웨어 이미지 파일명' }],
      forbiddeTableColumns: [
        { prop: 'basicinfoSubid', label: '명령어', sortable: false, searchable: false },
      ],
      legendTableColumns: [
        { prop: 'value', label: '예약어', width: 150, sortable: false, searchable: false },
        { prop: 'desc', label: '설명', sortable: false, searchable: false },
      ],
      serverCommandTableColumns: [
        { prop: 'commandName', label: '스크립트명', width: 120, sortable: false, searchable: false },
        { prop: 'commandContents', label: '스크립트 내용', sortable: false, searchable: false, formatter: this.getTableValueAfterCheckEmpty },
        { label: '실행', width: 80, scopedSlot: 'slot', align: 'center', sortable: false, searchable: false, formatter: this.getTableValueAfterCheckEmpty },
      ],
      netdeviceScriptTableColumns: [
        { prop: 'templateName', label: '스크립트명', width: 150, sortable: false, searchable: false },
        { prop: 'templateDescr', label: '설명', sortable: false, searchable: false, formatter: this.getTableValueAfterCheckEmpty },
      ],
      executeScriptTask: 'executeScriptTask',
    };
  },
  computed: {
    objManagetypeId() {
      return this.objInfo.obj.objManagetypeId;
    },
  },
  beforeDestroy() {
    if (this.$taskManager.existTask(this.executeScriptTask)) {
      this.$taskManager.removeTask(this.executeScriptTask);
    }
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    updateLegendTableLayout() {
      this.$nextTick(() => {
        this.$refs.legendTable.getTable().updateScrollY();
      });
    },
    /**
     * 스크립트 실행 팝업 load
     * @author jeee12
     */
    loadData() {
      if (this.objManagetypeId === 'SMS') {
        serverAPI.getServerPerformCommandList({
          objtypeId: this.objInfo.obj.objtypeId,
        }).then((response) => {
          if (response.data.success === true) {
            this.serverCommandList = response.data.data;
          }
        });

        basicInfoAPI.getList('EXECUTION_FORBIDDEN_COMMAND').then((response) => {
          if (response.data.success === true) {
            this.forbiddenCommandList = response.data.data;
          }
        });
      } else if (this.objManagetypeId === 'NMS') {
        netdeviceAPI.getNetdeviceTemplateScriptList({
          objId: this.objInfo.obj.objId,
        }).then((response) => {
          if (response.data.success === true) {
            this.netdeviceScriptList = response.data.data;
          }
        });
      }
    },
    /**
     * 명령어 수행 textfield keyup enter
     * @author jeee12
     */
    onTextFieldKeyupEnter() {
      this.onPerformCommandButtonClick(this.commandText, true);
    },
    /**
     * 명령어 수행 버튼 click
     * @author jeee12
     */
    onPerformCommandButtonClick(commandText, isCLi, scriptName) {
      if (this.objManagetypeId === 'SMS') {
        this.executeServerCommand(commandText, scriptName);
      } else if (this.objManagetypeId === 'NMS') {
        this.executeNetdeviceScript(commandText, isCLi, scriptName);
      }
    },
    /**
     * 서버 > 명령어 수행
     * @author jeee12
     * @param  {[type]} commandText 수행할 명령어
     */
    executeServerCommand(commandText, scriptName) {
      let isForbiddenMatch = false;
      if (isEmpty(commandText)) {
        this.$message(MsgUtil.getRequireInfoMsg(MsgUtil.action.INPUT, '명령어'));
        return;
      }

      this.forbiddenCommandList.forEach((command) => {
        const matcher = new RegExp(`\\s*${command.basicinfoSubid}\\s*`, 'i');
        if (matcher.test(commandText)) {
          this.$message(MsgUtil.getCustomMsgData('수행 불가능한 명령어가 포함되어있습니다.'));
          isForbiddenMatch = true;
        }
      });

      if (isForbiddenMatch === false) {
        this.isLoading = true;
        const obj = this.objInfo.obj;
        serverAPI.executeCLI({
          targetList: [{
            objId: obj.objId,
            objIp: obj.ipaddressApplytype === 'IPv4' ? obj.ipaddressIpv4 : obj.ipaddressIpv6,
          }],
          scriptName,
          executeCli: commandText,
        }).then((response) => {
          if (response.data.success === true) {
            if (isEmpty(response.data.data)) {
              this.$message(MsgUtil.getCustomMsgData('스크립트 수행 결과가 없습니다.'));
            } else {
              this.resultConsoleData += `\n${response.data.data}\n`;
            }
          }
          this.isLoading = false;
        });
      }
    },
    /**
     * 네트워크장비 > 스크립트 수행
     * @author jeee12
     * @param  {[type]} commandText 수행할 스크립트
     */
    executeNetdeviceScript(commandText, isCLi, scriptName) {
      if (isEmpty(commandText)) {
        this.$message(MsgUtil.getRequireInfoMsg(MsgUtil.action.INPUT, '스크립트'));
        return;
      }

      this.isLoading = true;
      let script;
      if (isCLi) {
        script = `$send$${commandText}\r\n$expectpromt$`;
      } else {
        script = commandText;
      }
      configAPI.executeScript({
        script,
        objIds: [this.objInfo.obj.objId],
        scriptName,
      }).then((result) => {
        const jobSeq = result.data.data;
        this.$taskManager.createTask(this.executeScriptTask, 5, () => {
          configAPI.getExecuteProgressRate({
            jobSeq,
          }).then((progressResult) => {
            const progressRate = progressResult.data.data;
            if (progressRate === 1) {
              this.$taskManager.removeTask(this.executeScriptTask);
              this.isLoading = false;
              this.loadNetdeviceScriptResult(jobSeq);
            }
          }).catch(() => {
            this.isLoading = false;
            this.$message(MsgUtil.getResultMsgData('수행', '스크립트', false));
          });
        }, false, 100, () => {
          this.$taskManager.removeTask(this.executeScriptTask);
          this.isLoading = false;
          this.$message(MsgUtil.getCustomResultMsgData('시간 초과로 스크립트 수행 결과를 조회하지 못하였습니다.', false));
          this.resultConsoleData = '';
        });
        this.$taskManager.startTask(this.executeScriptTask);
      });
    },
    /**
     * 네트워크 장비 스크립트 수행 결과 조회
     * @author jeee12
     */
    loadNetdeviceScriptResult(jobSeq) {
      configAPI.getExecuteScriptResult({ jobSeq }).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (isEmpty(data) || isEmpty(data[0].convertedJobResult)) {
            this.$message(MsgUtil.getCustomMsgData('스크립트 수행 결과가 없습니다.'));
            this.resultConsoleData = '';
          } else {
            this.$message(MsgUtil.getCustomResultMsgData('스크립트 실행을 완료하였습니다.', true));
            this.resultConsoleData = data[0].convertedJobResult;
          }
        }
      });
    },
    /**
     * 스크립트 설정 버튼 click
     * @author jeee12
     */
    onSettingButtonClick() {
      // TODO 환경설정으로 메뉴 이동 (환경설정 구현 후 수정 필요)
    },
    /**
     * 네트워크 장비 > 스크립트 목록 row click
     * @author jeee12
     */
    onScriptRowClick(row) {
      this.selectedScriptInfo = row;
    },
    /**
     * 테이블 데이터 빈 값 확인
     * @author jeee12
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 콘솔 clear 버튼 click
     * @author jeee12
     */
    onConsoleClearButtonClick() {
      this.resultConsoleData = '';
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.isLoading = false;
      this.commandText = '';
      this.resultConsoleData = '';
      if (this.objManagetypeId === 'NMS') this.selectedScriptInfo = null;

      if (this.$taskManager.existTask(this.executeScriptTask)) {
        this.$taskManager.removeTask(this.executeScriptTask);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/CommonScriptPopupButton.vue